//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { ArrowLeftOutlined, ArrowRightOutlined, InfoCircleFilled } from '@ant-design/icons';
import { Assignment, Close, Extension, WatchLater } from '@mui/icons-material';
//  -- Components ---------------------
import { Col, Popover, Row } from 'antd';
import { filter, find, get, map } from 'lodash';
import moment from 'moment';
import { lighten } from 'polished';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Birdimg, GradCalendar } from 'utils/assets/images';
//  -- Thunks -------------------------
import { handleCreatePastSubmission } from 'store/pastSubmission/thunks';
import styled from 'styled-components';
//  -- Constants ----------------------
import { Modal } from '@mui/material';
import Loading from 'components/Loading';
import RetakeModal from "components/RetakeModal";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import useMobileDeviceDetection from 'containers/chat/hooks';
import "moment-timezone";
import { Img } from 'react-image';
import { useBookUnits } from "store/booksUnits/selectors";
import { useCurrentClass, useCurrentClassBook } from 'store/classes/selectors';
import { useExams } from 'store/exams/selectors';
import { useOrgTimezone } from 'store/organizations/selectors';
import { useResources, useVideos } from 'store/resources/selectors';
import { useServertime } from 'store/servertime/selectors';
import { useStory } from "store/story/selectors";
import { useUserClasses } from 'store/userClasses/selectors';
import { handleGetStudentUserPreference } from 'store/userPreference/thunks';
import { BACK_TO_BOOK } from 'utils/config/reference';
import COLOR from 'utils/constants/color';
import { generateUrlForNonEbook, getAssignmentNavigationUrl, getBookDisplayName, getEbookAssignmentDeepLinkUrl, getExceptionStatus, getStoryUrl, getUserAssignment, imageFetch, imageFetchFromPodcast, isVideo } from 'utils/lib/ebookHelper';
import { isBeforTime } from "utils/methods/math";
import PopoverContent from 'components/UI/PopoverConf/Popover';
import { isDisabledForMe } from 'utils/methods/validateData';
import { useUserAllowedBooks } from 'store/books/selectors';
import { modifyUrlParams } from 'modules/assignments/helper';
import { getCoverForAssignment, isWaitingForAiGradingRestriction } from 'utils/methods/functions';
import useActiveStudentofParent from 'components/hooks/parent/activeStudentofParent';
import { useUserProfileConfig } from 'store/users/selectors';
import { usePageCover } from 'components/hooks/pageCover/pageCover';
import { updateUI } from 'store/UI/actions';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import useNotification from 'components/hooks/notification/useNotification';
import { useAudioPermissionCheck } from 'components/hooks/useAudioPermission/useAudioPermissionCheck';
import MicrophonePermissionModal from 'components/UI/modal/MicrophonePermissionModal';
import SentryWrap from 'components/Sentry';
import { sortAssignmentsByCalendarOrder } from 'utils/methods/calendarAssignmentOrder';
import useIsExamActive from 'components/hooks/books/useIsExamActive';
import useCheckAudioAndWritten from 'components/UI/scoreMessage/useCheckAudioAndWritten';
import { setWorksheetView } from 'store/worksheetView/action';
import { handleListQuestionOfWorksheet } from 'store/worksheet/thunks';
import { handleSubmitWorksheetAssignment } from 'store/activities/thunks';
import { handleListUserSubmissionsByClass } from 'store/submissions/thunks';
import { useClassGameActivity } from 'store/one_game/selectors';
import dayjs from 'utils/dayjsConfig';
import * as Sentry from '@sentry/react';
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const AssignmentContainer = styled.div`
    border: 1px solid #F4F5F7;
    height: 100%;
    min-height: 160px;
    padding 8px 4px;
`;

const Container = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 16px;
`;

const ContainerDay = styled.div`
    border-bottom: 4px solid #03989e82;
    border-right: 2px solid #03989e82;
    border-left: 2px solid #03989e82;
    flex: 1;
    margin-bottom: 16px;
    margin-right: 8px;
    min-width: 124px;

    &:last-child {
        margin-right: 0px;
    }
`;
const CalendarDay = styled.div`
    background-color:${p => p.isToday ? COLOR.orange100 : "#5f4c82"};
    border:3px solid #c5a1cf;
    border-radius: 15px;
    padding: 10px;
    position: relative;
    flex: 1;
    margin-bottom: 16px;
    margin-right: 8px;
    min-width: 200px;
    min-height: 180px;
    &:last-child {
        margin-right: 0px;
    }
`;
const HeaderRow = styled.div`
    flex-direction: row;
    display: flex;
`
// const CalendarIcon = styled.div`
//     flex: 1;
//     background-image: url(${Calendarimg});
//     background-repeat: no-repeat;
//     background-size: 200% 200%;
//     height: 20px;
//     background-position: center;
// `
const GradCalendarSec = styled.div`
    display:flex;
    align-items: center;
    justify-content: space-between;

`
const Birtdimg = styled.img`
    height: 180px;
    width: 220px;
    position: absolute;
    top: -77px;
    left: -110px;
    z-index: 0;
    background-color: transparent;
    user-select: none;
      @media screen and (max-width: 600px) {
       left:-100px;
    }
`
const DayTxt = styled.div`
    flex: 6;
    color: white;
    font-size: 20px;`
const ControlRow = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

const CustomRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
`;

const Date = styled.span`
    color:#fff;
    display: block;
    font-size: 11px;
    line-height: 10px;
    margin-bottom: 6px;
`;

const DayOfWeek = styled.span`
    background-color: #03989e82;
    border-radius: 2px;
    color: ${COLOR.black};
    display: block;
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
    padding: 12px 12px;
`;

const Header = styled.span`
    color: ${COLOR.black600};
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
`;

const HeaderBold = styled(Header)`
    color: ${COLOR.black100};
`;

const Item = styled.div`
    align-items: center;
    background-color: ${p => p.deactivated ? COLOR.redishpink : p.disabled ? COLOR.green900 : (p.past ? lighten(0.4, 'red') : COLOR.white)};
    border: 1px dashed ${p => (p.deactivated || p.disabled || p.past) ? COLOR.white : COLOR.black700};
    border-radius: 2px;
    color: ${p => (p.deactivated || p.disabled) ? COLOR.white : COLOR.black200};
    cursor: ${p => p.past ? 'not-allowed' : 'pointer'};
    display: flex;
    flex-direction: row;
    font-size: 13px;
    line-height: 15px;
    margin-bottom: 4px;
    position: relative;
    text-transform: capitalize;
    transition: all 450ms ease;
    width: 100%;

    @media (min-width: 1000px) {
        &:hover {
            background-color: ${p => !p.past && '#f9f9f9'};
            color: ${p => !p.past && COLOR.green};
            box-shadow: ${p => !p.past && '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)'};
        }
    }
`

const Wrapper = styled.div`
    width: 100%;
`;
const NoUpcoomingText = styled.div`
    color: ${COLOR.radish100};
    font-size: 14px;
    line-height: 16px;
    margin-top: 16px;
    margin-bottom: 50px;
`;
const ItemTab = styled.button`
    height:100%;
    width:80%;
    background: none;
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    padding:8px;
    cursor: pointer;
`;
const ItemTab2 = styled.button`
    height:100%;
    width:10%;
    background: none;
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    padding:8px;
    cursor: pointer;
`;
const Image = styled.img`
    border: 1px solid ${COLOR.black800};
    width: 100%;
    height: auto;
`;
const ImageModal = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90vw;
    height: 90vh;
    margin-top:20px;
`;
const ModalDescription = styled.div`
    background: #E7E8EA;
    display: flex;
    padding: 5px;
    flex-direction: column;
    position:relative;
`;
const ModelDescRow = styled.div`
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 10px;
    position:absolute;
    background:#E7E8EA;
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    height:35px;
    border-bottom:.5px solid lightgray;
    margin-top:-35px;
`;
const StyledImg = styled(Img)`
  width: ${({ imgType }) => (imgType ? "70vw" : "100%")};
  height: 100%;
  max-width: 90vw;
  max-height: 80vh;
  object-fit: contain;

  @media (min-width: 1367px) {
    width: ${({ imgType }) => (imgType ? "34vw" : "100%")};
  }

  @media (max-width: 600px) {
    max-height: 70vh;
  }
`;
const CloseBtn = styled.div`
    background-color: rgb(204, 80, 71);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    z-index: 2;
    position:absolute;
    top:-45px;
    right:-13px;
`;
const AssignmentNameText = styled.span`
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
//  ----------------------------------------------------------------------------
//  Feature
//  ----------------------------------------------------------------------------
//
//  Calendar
//
//  -- Description
//  Calendar of events for quick view
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const Calendar = ({
    assignments,
    submissions,
    booksAllList,
    userBooks,
    currentUser,
    userPreference
}) => {
    const showAlert = useAlert();
    const userAllowedBooks = useUserAllowedBooks()
    const deviceType = useMobileDeviceDetection();
    const servertime = useServertime()
    const timezone = useOrgTimezone()
    const story = useStory()
    const [modalOpen, setModalState] = useState(false);
    const [activeAssignment, setActiveAssignment] = useState(null)
    const [isRetakeOpen, setisRetakeOpen] = useState(false);
    const currentClass = useCurrentClass()
    const [assignmentData, setAssignmentData] = useState({ data: null, submission: null, retakeAvailable: null })
    const resources = useResources()
    const exams = useExams();
    const videos = useVideos()
    const dispatch = useDispatch();
  	const navigate = useNavigate();
    const bookUnits = useBookUnits()
    const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const [selectedDay, setSelectedDay] = useState(moment());
    const weekStart = selectedDay.clone().startOf('isoWeek');
    const allowed_books = useCurrentClassBook();
    const userClasses = useUserClasses();
    const { activeStudentParent } = useActiveStudentofParent();
    const userAssignment = getUserAssignment(allowed_books, assignments, currentUser, currentClass,userAllowedBooks?.other_permissions?.resourses,activeStudentParent)
    const { isAiPermissionEnabled } = useUserProfileConfig();
    const { updatePopUpAtOnce } = usePopUpAtOnce();
    const { readSingleNotification } = useNotification();
    const {checkAudioQuestionsAndRequestPermission} = useAudioPermissionCheck();
    const [onClickConfig, setOnClickConfig] = useState(null);
    const {checkAllTypeExamBook} = useIsExamActive();
    const {isCheckAudioAndWritten, isCheckAudiOrWritten} = useCheckAudioAndWritten({questions: []});
    const { class_game_activity } = useClassGameActivity();
    const isExamHidden = (chapter) => {
        const fetchExams = exams?.find((entry) => entry.exams.flatMap((exam) => `${exam.bookId}`).includes(`${chapter}`));
        if (!fetchExams) {
            return false;
        }
        const classInfo = find(userClasses, ['id', currentClass?.id]);
        const isHidden = classInfo?.config?.meta_data || {};
        const examLevel = fetchExams?.exam_school || '';
        if (isHidden.highSchool && examLevel === 'high') {
            return true;
        }
        if (isHidden.middleSchool && examLevel === 'middle') {
            return true;
        }
        return false;
    };
    const generateDays = () => {
        const days = [];

        for (let i = 0; i <= 6; i++) {
            days.push(moment(weekStart).add(i, 'days'))
        }

        return days;
    };
    const WEEK = generateDays();

    useEffect(() => {
        getPref();
    }, [currentClass])

    const getPref = async () => {
        if(currentUser?.role !== 'parent'){
            await dispatch(handleGetStudentUserPreference(currentClass?.teacherId, currentUser?.id));
        }
       // await dispatch(handleGetStudentUserPreference(currentClass?.teacherId, currentClass?.id));
        // setDueDatePref(getDuePref)
    }

    const generateUrl = (CHAPTER_ID, page, activity, quiz, is_graphic_organizer) => {
        const storyUrl = getStoryUrl(story, CHAPTER_ID, page, quiz, activity)
        const backToLabel = BACK_TO_BOOK[CHAPTER_ID]
        const BALCON_PAGES = get(find(bookUnits, ["bookId", CHAPTER_ID]), "pages", [])
        const bookitem = find(BALCON_PAGES, k => parseInt(k.start) <= page && parseInt(k.finish) >= page)
        const url = generateUrlForNonEbook(bookitem?.id, page, activity, quiz, backToLabel, null, CHAPTER_ID, is_graphic_organizer)
        if (url && backToLabel) {
            return url;
        }
        else if (storyUrl) {
            return storyUrl;
        } else {
            return null;
        }
    }
    const getNumberMask = (chapter, page) => {
        const book = find(booksAllList, { id: chapter });
        if (book) {
            const numberMask = find(book.pages, (k) => k.pageId == page);
            if (numberMask?.NumberMasked) {
                return numberMask.NumberMasked;
            }
        }
        return page;
    };

    const assignmentInfoData = (worksheetInfo) => {
        if (
            worksheetInfo &&
            worksheetInfo.id &&
            Array.isArray(class_game_activity) &&
            class_game_activity.length > 0
        ) {
            const activity = class_game_activity.find(
                (k) => k.game_id == worksheetInfo.id && k.classId == currentClass.id
            );
            if (activity) return activity;
            return {};
        }
        return {};
    };

    const resolveWorksheetSubmission = (data, submission) => {
        if (submission && (submission.assignmentId || submission.id)) {
            return submission;
        }
        return find(submissions, (k) =>
            k.assignmentId == data?.data?.id ||
            k.assignmentId == data?.activityId ||
            (data?.type === 'worksheet' &&
                (k.assignmentId == data?.session_id || k.assignmentId == data?.game_id))
        ) || null;
    };

    const fetchCurrentSubmissionData = async (worksheetId, worksheetSubmission) => {
        try {
            if (!worksheetSubmission?.id) {
                const submitDataObj = {
                    worksheet_id: worksheetId,
                    answer: [],
                    class_id: currentClass.id,
                    student_id: currentUser.id,
                    time_duration: 0,
                    total_correct_answer: 0,
                    total_wrong_answer: 0,
                    finish_later: 0,
                    complete: false,
                    submissions: 0,
                };
                await dispatch(handleSubmitWorksheetAssignment(submitDataObj));
                dispatch(handleListUserSubmissionsByClass(currentUser?.id, currentClass?.id));
            }
        } catch (error) {
            Sentry.captureException(error);
        }
    };

    const graphicOrganizationRedirect = async (data, submission) => {
        const url = getEbookAssignmentDeepLinkUrl(data);
        if (url?.includes('worksheet')) {
            const worksheetId = data?.data?.id ?? data?.game_id;
            const isWorksheet =
                data?.type === 'worksheet' || data?.data?.type === 'worksheet';
            const hasSubmission = isWorksheet
                ? resolveWorksheetSubmission(data, submission)
                : null;
            const assignmentInfo = assignmentInfoData(data?.assignment);
            const scheduleAt = assignmentInfo?.scheduleAt;
            const dueDate = assignmentInfo?.dueDate;
            const now = dayjs();
            const isWithinSchedule =
                scheduleAt && dueDate
                    ? now.isAfter(dayjs(scheduleAt)) && now.isBefore(dayjs(dueDate))
                    : true;
            const is_practice_mode =
                hasSubmission?.complete || !isWithinSchedule ? true : false;
            const response = await dispatch(
                handleListQuestionOfWorksheet(worksheetId)
            );
            if (!is_practice_mode) {
                await fetchCurrentSubmissionData(worksheetId, hasSubmission);
            }
            const questionArray = [];
            if (Array.isArray(response)) {
                response.forEach((element) => {
                    if (!element?.id) return;
                    element.question.id = element?.question_id;
                    questionArray.push({
                        ...element?.question,
                        image: element?.image,
                        answer_audio: element?.answer_audio,
                        question_audio: element?.question_audio,
                    });
                });
            }
            const isResuming =
                hasSubmission &&
                hasSubmission.complete === false &&
                !is_practice_mode;
            const resumeData = isResuming
                ? {
                    activeIndex: hasSubmission.answers?.length || 0,
                    studentSubmission: hasSubmission.answers || [],
                    isCorrect:
                        hasSubmission.answers?.filter((a) => a.isCorrect)?.length || 0,
                }
                : null;
            const isAssigned = !!assignmentInfo?.id;
            const isActiveSchedule = !isAssigned || isWithinSchedule;
            const for_grade = isActiveSchedule && !hasSubmission?.complete;
            const chapter = data?.data?.chapter;
            const page = data?.data?.page;
            await dispatch(
                setWorksheetView({
                    open: true,
                    questions: questionArray,
                    title: data?.data?.displayName,
                    GetBookName: getBookDisplayName(
                        booksAllList,
                        chapter,
                        true,
                        videos,
                        resources
                    ),
                    bookId: getNumberMask(chapter, page) || data?.bookId,
                    assignmentInfo,
                    for_grade,
                    has_submission: is_practice_mode,
                    resumeData,
                })
            );
            // return true;
        }
        if (url) {
            navigate(url);
            return true;
        }
        return false;
    };
    const getEngageData = (data) => {
        try{
          const currentEngage = data?.data?.config_assignment?.engage_id;
          if(currentEngage){
            const currentBook = booksAllList?.find((book) => book.id == data?.data?.bookId);
            const allEngage = currentBook?.engage;
            const engage = find(allEngage, { id: currentEngage });
            return engage;
          }else{
            return null;
          }
        }catch(error){
          console.log(error,"error");
        }
      }

    const onClick = async (data, submission, retakeAvailable) => {
        setOnClickConfig(null);
        const chapter = get(data, "data.chapter") || get(data, "assignment.chapter")
        const assignmentId = get(data, "data.id") || get(data, "game_id")
        const assignmentPage = get(data, "data.page") || get(data, "assignment.page")
        if (get(currentUser, "role") === "student" && isExamHidden(chapter)) {
            showAlert('Your teacher has hidden this exam and you are no longer able to take it.', 'info');
            return;
        }
        readSingleNotification(chapter,assignmentPage,currentUser,data);
        const typeId = get(data, "data.typeId", "") || ''
        const is_graphic_organizer = get(data, "data.type") === "graphic_organizer" || get(data, "data.activity_type") === "graphic_organizer"
        const generatedUri = generateUrl(chapter, assignmentPage, typeId.includes('activity') ? assignmentId : null, typeId.includes('quiz') ? assignmentId : null, is_graphic_organizer)
        if(checkAllTypeExamBook(chapter) && isCheckAudioAndWritten(data?.data?.questions) && !submission?.id && data?.data?.questions?.length > 0){
          setTimeout(() => {
            dispatch(updateUI({ openScoreMessageModal: {open: true, category: data?.ai_grading_config?.grade_level} }));
          }, 1000);
        }
        console.log(generatedUri, "generatedUri")
        if (submission?.complete && !retakeAvailable) {
            return;
        } else if (submission?.complete && retakeAvailable) {
            console.log("submission?.complete && retakeAvailable")
            await dispatch(handleCreatePastSubmission({ submissionId: submission?.id , is_missing: submission?.exceptionStatus ==3?true: false }))
            if (data?.data?.config_assignment?.isFrom === 'engagement') {
                const findEngageData = getEngageData(data);
                if (findEngageData && findEngageData?.imageData?.length > 0) {
                   updatePopUpAtOnce(false);
                  dispatch(updateUI({ openEngageModalTeacher: { open: true, data: findEngageData?.imageData, isCheckAudiOrWritten: isCheckAudiOrWritten(data?.data?.questions) } }));
                }
              }
            // await dispatch(handleUpdateSubmission(submission?.id, {
            //     ...submission,
            //     complete: false,
            //     retaking: true,
            //     answers: [],
            //     graded: false,
            //     feedback: '',
            //     audioFeedback: null,
            //     timmer: 0
            // }))
            if(data?.assignfrom?.urlPath){
                const modifiedUrl = modifyUrlParams(data.assignfrom.urlPath, {
                    activity: typeId === 'activity' ? assignmentId : null,
                    quiz: typeId === 'quiz' ? assignmentId : null,
                });
                
                console.log(modifiedUrl, "modifiedUrl")
                navigate(modifiedUrl);
                return;
            }
            if (isVideo(chapter, resources)) {
                redirectToAssignmentVideo(chapter, assignmentId,data);
            }
            else if (generatedUri) {
                console.log(generatedUri, "generatedUri")
                navigate(getAssignmentNavigationUrl(generatedUri, data));
            }
            else {
                if (!(await graphicOrganizationRedirect(data, submission))) {
                    navigate(`/ebook?chapter=${chapter}&page=${assignmentPage}&activity=${typeId === 'activity' ? assignmentId : null}&quiz=${typeId === 'quiz' ? assignmentId : null}`);
                }
            }
        } else {
            if (data?.data?.config_assignment?.isFrom === 'engagement') {
                console.log("else", data?.data?.config_assignment?.isFrom)
                const findEngageData = getEngageData(data);
                if (findEngageData && findEngageData?.imageData?.length > 0) {
                  dispatch(updateUI({ openEngageModalTeacher: { open: true, data: findEngageData?.imageData } }));
                }
              }
              if(data?.assignfrom && data?.assignfrom?.urlPath){
                  console.log("data?.assignfrom && data?.assignfrom?.urlPath")
                  if(data?.assignfrom?.urlPath?.includes('/video')){
                      navigate(getAssignmentNavigationUrl(`/video?id=${chapter}&quiz=${assignmentId}`, data));
                      return;
                    }
                 const modifiedUrl = modifyUrlParams(data.assignfrom.urlPath, {
                    activity: typeId === 'activity' ? assignmentId : null,
                    quiz: typeId === 'quiz' ? assignmentId : null,
                });
      
                navigate(modifiedUrl);
                return;
            }
            if (isVideo(chapter, resources)) {
                console.log("isVideo", chapter, assignmentId, data)
                redirectToAssignmentVideo(chapter, assignmentId,data);
            } else if (generatedUri) {
                console.log("generatedUri", generatedUri, data)
                navigate(getAssignmentNavigationUrl(generatedUri, data));
            }
            else {
                console.log("else", chapter, assignmentPage, assignmentId, data)
                if (!(await graphicOrganizationRedirect(data, submission))) {
                    navigate(`/ebook?chapter=${chapter}&page=${assignmentPage}&activity=${typeId === 'activity' ? assignmentId : null}&quiz=${typeId === 'quiz' ? assignmentId : null}`);
                }
            }
        }

    };
    const redirectToAssignmentVideo = (id, quizId,data) => {
        // const getUri = (q, a) => (`video?id=${id}&quiz=${q}&activity=${a}&link=${search.link}`)
        let url = `/video?id=${id}&quiz=${quizId}`
        navigate(getAssignmentNavigationUrl(url, data));
    }
    // const getNumberMask = (chapter, _page) => {
    //     let book = find(booksAllList, { id: chapter })
    //     if (book) {
    //         let numberMask = find(book.pages, k => k.pageId == _page)
    //         if (numberMask) {
    //             return numberMask.NumberMasked
    //         } else {
    //             return _page;
    //         }
    //     } else {
    //         return _page;
    //     }
    // }

    const viewInfo = (x) => {
        setActiveAssignment(x)
        setModalState(true)
    }
    const closeViewinfo = () => {
        setModalState(false)
        setActiveAssignment(null)
    }
    const is_soy_story = useMemo(() => activeAssignment && ((typeof activeAssignment.storyInstruction == "string" && activeAssignment.storyInstruction.length > 0) || (activeAssignment?.data && typeof activeAssignment?.data.storyInstruction == "string" && activeAssignment?.data.storyInstruction.length > 0)), [activeAssignment])
    const is_article_level = useMemo(() => activeAssignment && ((typeof activeAssignment.article_level_id == "string" && activeAssignment.article_level_id.length > 0) || (activeAssignment?.data && typeof activeAssignment?.data.article_level_id == "string" && activeAssignment?.data.article_level_id.length > 0)), [activeAssignment])
    const is_worksheet = useMemo(() => activeAssignment && activeAssignment.type === 'worksheet' || activeAssignment?.data?.type === 'worksheet' || activeAssignment?.data?.assignmentType === 'worksheet', [activeAssignment])
    const pageCover = usePageCover({ assignmentData: activeAssignment?.data });
    const modalSrc = () => {
        if(pageCover){
            return pageCover;
        }
        const chapter_id = get(activeAssignment, "data.chapter") || get(activeAssignment, "assignment.chapter")
        const page_id = get(activeAssignment, "data.page") || get(activeAssignment, "assignment.page")
        const cover_img_ext = getCoverForAssignment(activeAssignment)
        if (cover_img_ext) return cover_img_ext;
        return isVideo(page_id, resources) ? imageFetchFromPodcast(page_id, resources) : imageFetch(booksAllList, chapter_id, page_id)
    }
    const isWaitingForAiGrading = (submission,x) => {
      const is_waiting = isWaitingForAiGradingRestriction(submission,x,isAiPermissionEnabled);
      if (is_waiting) {
        showAlert('Please wait while the AI processes your grading.', 'warning');
        return true;
      }
      //       if((Array.isArray(submission?.ai_grade) && submission?.ai_grade.length == 0)||( isPlainObject(submission?.ai_grade)&&isEmpty(submission?.ai_grade))){
      //     const is_waiting = submission.waiting_for_ai_grade
      //     if (is_waiting) {
      //         showAlert("Please wait while the AI processes your grading.", "warning")
      //         return true
      //     }
      // }
      return false;
    };

    const onClickAssignment = async (x,submission, deactivateForStudent, isActive, retakeAvailable) => {
        if (x?.data) {
            const hasAudioPermission = await checkAudioQuestionsAndRequestPermission(x?.data);
            setOnClickConfig({
                hasAudioPermission: hasAudioPermission,
                x: x,
                submission: submission,
                deactivateForStudent: deactivateForStudent,
                isActive: isActive,
                retakeAvailable: retakeAvailable
            })
            if (!hasAudioPermission) {
              return;
            }
          }
        if (!isActive || deactivateForStudent) {
            return;
        }
        if (submission?.complete && retakeAvailable) {
            if(isWaitingForAiGrading(submission,x)) {
                return;
            }
            setisRetakeOpen(true)
            setAssignmentData({
                data: x,
                submission: submission,
                retakeAvailable: retakeAvailable
            })
        } else {
            onClick(x, submission, retakeAvailable)
        }
    }

    return (
    <SentryWrap>
        <Wrapper>
        <MicrophonePermissionModal grantedAllow={()=>onClickAssignment(onClickConfig?.x,onClickConfig?.submission, onClickConfig?.deactivateForStudent, onClickConfig?.isActive, onClickConfig?.retakeAvailable)} />
            <RetakeModal isRetakeOpen={isRetakeOpen} onClose={() => {
                setAssignmentData({
                    data: null,
                    submission: null,
                    retakeAvailable: null
                })
                setisRetakeOpen(false)
            }}
                onSubmit={() => onClick(assignmentData.data, assignmentData.submission, assignmentData.retakeAvailable)} />
            {/* <Modal
                open={modalOpen}
                onClose={closeViewinfo}
                style={{ height: '100%', width: '100%' }}
            >
                <ImageModal>
                    <ModalDescription>
                        <CloseBtn onClick={closeViewinfo}>
                            <Close style={{ color: "#fff", fontWeight: "bolder", fontSize: 12 }} />
                        </CloseBtn>
                        <ModelDescRow>{getBookDisplayName(booksAllList, get(activeAssignment, "data.chapter"), true, videos, resources)}</ModelDescRow>
                    </ModalDescription>

                    <Img
                        style={{ height: "auto", width: "100%", border: `1px solid ${COLOR.black800}` }}
                        src={modalSrc()}
                        loader={<Loading />}
                    />
                </ImageModal>
            </Modal> */}
            <Modal open={modalOpen} onClose={closeViewinfo} className="imgModl">
                <ImageModal>
                    <div className="mdlcont">
                        <CloseBtn onClick={closeViewinfo}>
                            <Close className="closeIcns" />
                        </CloseBtn>
                        <ModelDescRow>
                            {getBookDisplayName(booksAllList, get(activeAssignment, "data.chapter"), true, videos, resources)}
                        </ModelDescRow>
                       {Boolean(is_soy_story || is_worksheet || is_article_level) && (
                        <label className='storyTitleCstm'>{activeAssignment ? activeAssignment?.displayName ? activeAssignment?.displayName : activeAssignment?.data?.displayName: null}</label>
                         )}
                        <StyledImg imgType={isVideo(get(activeAssignment, "data.page"), resources)} src={modalSrc()} loader={<Loading />} />
                    </div>
                </ImageModal>
            </Modal>
            <Row gutter={[0, 16]}>
                <Col span={24}>
                    <ControlRow>
                        <Header style={{ marginLeft: 30 }}>Week <HeaderBold>{WEEK[0].format('D MMMM')} - {WEEK[6].format('D MMMM')}</HeaderBold></Header>
                        <CustomRow>
                            <ArrowLeftOutlined
                                onClick={() => setSelectedDay(moment(selectedDay).subtract(7, 'days'))}
                                style={{ color: COLOR.black500, cursor: 'pointer', marginLeft: '16px' }}
                            />
                            <ArrowRightOutlined
                                onClick={() => setSelectedDay(moment(selectedDay).add(7, 'days'))}
                                style={{ color: COLOR.black500, cursor: 'pointer', marginLeft: '8px' }}
                            />
                        </CustomRow>
                    </ControlRow>
                </Col>
            </Row>
            <div style={{ position: 'relative' }}>
               <Birtdimg src={Birdimg} />
                <Container className='CalforIpad' style={{ marginTop: 16, flexDirection: deviceType ? 'column' : 'row' }}>
                {WEEK.map((day, i) => {
                    return (
                        <CalendarDay isToday={moment().isSame(day, 'day')} key={day.unix()} style={{ width: deviceType ? '100%' : 'unset' }}>
                            <GradCalendarSec>
                                <Date>{day.format('D MMMM')}</Date>
                                <img src={GradCalendar} style={{width:"20px"}}/>
                            </GradCalendarSec>
                            <HeaderRow>
                                <DayTxt>{DAYS[day.day()]}</DayTxt>
                                {/* <CalendarIcon style={{ flex: deviceType ? 'none' : '1', height: deviceType ? 40 : 25, width: deviceType ? 45 : 30 }}></CalendarIcon> */}
                            </HeaderRow>
                            <AssignmentContainer style={{ paddingLeft: 0, paddingRight: 0, borderWidth: 0, minHeight: 0 }}>
                                {map(
                                    sortAssignmentsByCalendarOrder(
                                        filter(userAssignment, (jx) => {
                                            const getHiddenBooks = get(currentClass,"hide_books",[]).map(data => data?.bookId) || [];
                                            if(get(currentUser,"role")=='student' && getHiddenBooks?.includes(jx?.data?.chapter||jx?.chapter)){
                                                return false;
                                            }
                                            let dueDateOrderRow = userPreference?.order_by_date === 'start_date' ? jx.scheduleAt : userPreference?.order_by_date === 'late_submission' ? jx.lateDate || jx.dueDate : jx.dueDate;
                                            return moment(dueDateOrderRow).format('MDYY') === day.format('MDYY');
                                        }).sort((a, b) => {
                                            const sa = Number(get(a, 'meta_data.sequence', Number.MAX_SAFE_INTEGER));
                                            const sb = Number(get(b, 'meta_data.sequence', Number.MAX_SAFE_INTEGER));
                                            return sa - sb;
                                        }),
                                        null
                                    ),
                                    x => {
                                     const submission = find(submissions,k=>k.assignmentId ==  x.data?.id || k.assignmentId == x.activityId);
                                    const { isException, exceptionStatusText } = getExceptionStatus(submission, currentUser)
                                    const hasTooltip = !isNaN(parseInt(x.timeDuration)) && parseInt(x.timeDuration) > 0
                                    const deactive_for_me = isDisabledForMe(x,currentUser.id)
                                    const isActive = get(x, "active", true) && !deactive_for_me;
                                    const deactivateForStudent = x?.deactivated_student?.includes(currentUser?.id);
                                    const displayName = get(x, 'displayName', get(x, 'data.displayName', ''));
                                    let isBeforeLateDate = true
                                    const retakeAvailable = submission?.exceptionStatus ==3?true: submission ? parseInt(submission?.submissions, 10) < (parseInt(x?.retakes, 10) + 1) : true;
                                    let dueDate = x.dueDate;
                                    if (x?.lateDate == "always") {
                                        isBeforeLateDate = false
                                    } else {
                                        isBeforeLateDate = typeof x?.lateDate == "undefined" || !x?.lateDate ? true :  isBeforTime(x?.lateDate, servertime, timezone);
                                    }
                                        const isPast = isBeforTime(dueDate, servertime, timezone)
                                        if (isPast && isBeforeLateDate) {
                                            return (
                                                // <TootipWrapper label={!isActive || deactivateForStudent ? "Assignment is deactivated by teacher" : get(x, "displayName", get(x, "data.displayName", ""))} hasToolTip key={x.id}>
                                                <Popover placement="rightTop" content={<PopoverContent booksAllList={booksAllList} x={x} currentUser={currentUser} currentClass={currentClass} />} title="Assignment Info" trigger="hover">
                                                    <Item key={x.id} past onClick={e => e.preventDefault()}>
                                                        <ItemTab>
                                                            {x?.assignment?.type === 'activity'
                                                                ? <Extension style={{ height: '18px', marginRight: '4px' }} />
                                                                : <Assignment style={{ height: '18px', marginRight: '4px' }} />
                                                            }
                                                            {/* {x?.activityId ? 'Activity' : 'Quiz'} ({x?.activityId ? 'A' : 'Q'} */}
                                                            <AssignmentNameText  className='text-wrap'>
                                                                {/* {getAssignmentLable(x, booksAllList, videos, resources)} */}
                                                                {displayName}
                                                            </AssignmentNameText>
                                                            <br />
                                                            {!isActive || deactivateForStudent ? "(Deactivated)" : null}
                                                            {/* ) */}
                                                        </ItemTab>
                                                        <ItemTab2 onClick={() => viewInfo(x)}>
                                                            <InfoCircleFilled />
                                                        </ItemTab2>
                                                    </Item>
                                                </Popover>
                                            );
                                        } else {
                                            return (
                                                // <TootipWrapper
                                                //     hasToolTip label={!isActive || deactivateForStudent ? "Assignment is deactivated by teacher" : (hasTooltip && !(get(submission, "complete", false) && !retakeAvailable)) ? "This activity includes a timer, are you sure you want to start it?" : isException ? `Assignment is marked as ${exceptionStatusText}` : get(x, "displayName", get(x, "data.displayName", ""))} key={x.id}>
                                                <Popover placement="rightTop" content={<PopoverContent booksAllList={booksAllList} x={x} currentUser={currentUser} currentClass={currentClass} />} title="Assignment Info" trigger="hover">
                                                    <Item
                                                        // past={isException}
                                                        disabled={(submission?.complete && !retakeAvailable)}
                                                        deactivated={!isActive || deactivateForStudent} >
                                                        <ItemTab
                                                            disabled={(submission?.complete && !retakeAvailable)}
                                                            deactivated={!isActive || deactivateForStudent}
                                                            onClick={()=>onClickAssignment(x,submission, deactivateForStudent, isActive, retakeAvailable)}
                                                        >
                                                            {x?.data?.typeId === 'activity'
                                                                ? <Extension style={{ height: '18px', marginRight: '4px' }} />
                                                                : <Assignment style={{ height: '18px', marginRight: '4px' }} />
                                                            }
                                                            {/* {x?.activityId ? 'A' : 'Q'} */}
                                                            <AssignmentNameText>
                                                                {/* {getAssignmentLable(x, booksAllList, videos, resources)} */}
                                                                {displayName}
                                                                <p style={{margin: 0}}>{!isActive || deactivateForStudent ? "(Deactivated)" : (isException ? `(${exceptionStatusText})` : (submission?.complete && retakeAvailable  ? "(Retake)"  : (submission?.complete ? '(Completed)' : (submission ? '(Resume)' : '(Due)'))))}</p>
                                                            </AssignmentNameText>

                                                            {hasTooltip &&
                                                                <WatchLater style={{ height: '18px', marginLeft: '4px', marginTop: '4px' }} />
                                                            }
                                                        </ItemTab>
                                                        <ItemTab2 onClick={() => viewInfo(x)}>
                                                            <InfoCircleFilled />
                                                        </ItemTab2>
                                                    </Item>
                                                </Popover>
                                            );
                                        }
                                })}
                            </AssignmentContainer>
                        </CalendarDay>
                    )
                })}
                </Container>
                </div>
        </Wrapper>
    </SentryWrap>
    );
};



export default Calendar;

